<template>
<div class="partner" id="partners">
  <div class="module-logo">
    <img class="partner-img" :src="isMobile ? 'https://static001.geekbang.org/resource/image/eb/fa/eb01b5ddf37b2ae83606402cbacd93fa.png' : 'https://static001.geekbang.org/resource/image/53/fa/533e6e27f10625ca0b1012d997df69fa.png'" alt="">
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['data'],
  components: {
  },
  computed: {
    ...mapState(['isMobile'])
  }
}
</script>

<style lang="scss" scoped>

.partner {
  background: $bgGrey;
}

.module-logo {
  display: flex; align-items: center; justify-content: center;
  height: 400px;
  background: url('https://static001.geekbang.org/resource/image/50/4e/502eb0526ea3a56323f278d801e5024e.png') center / cover no-repeat;

  @include mobile {
    height: 686px;
    background: url('https://static001.geekbang.org/resource/image/96/c5/9656559cfcf2352b2532a1782c725ec5.png') center / cover no-repeat;
  }
}

.partner-img {
  width: 1077px; height: 206px;

  @include mobile {
    width: 266px; height: 590px;
  }
}

</style>
